exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-border-box-11{position:relative;width:100%;height:100%}.dv-border-box-11 .dv-border-svg-container{position:absolute;width:100%;height:100%;top:0;left:0}.dv-border-box-11 .dv-border-svg-container>polyline{fill:none;stroke-width:1}.dv-border-box-11 .border-box-content{position:relative;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/borderBox11/src/main.css
// module id = 1069
// module chunks = 45